<template>
    <div>
        <a-drawer
            :title="$t('program.upload_related_video.title' /* 上传视频 */)"
            width="50%"
            placement="right"
            :closable="true"
            :body-style="{ height: 'calc(100vh - 57px)', paddingBottom: '50px', overflow: 'auto' }"
            :visible="visible"
            @close="handleCloseEvent"
        >
            <a-spin :spinning="loading">
                <a-form :form="form" v-if="visible">
                    <a-row :gutter="[10, 0]">
                        <a-col>
                            <a-form-item>
                                <a-input type="hidden" v-decorator="['file_size']" />
                            </a-form-item>
                            <a-form-item>
                                <a-input type="hidden" v-decorator="['duration']" />
                            </a-form-item>
                            <a-form-item>
                                <a-input type="hidden" v-decorator="['remark']" />
                            </a-form-item>
                            <a-form-item>
                                <a-input type="hidden" v-decorator="['program_type']" />
                            </a-form-item>
                            <a-form-item>
                                <a-input type="hidden" v-decorator="['program_id']" />
                            </a-form-item>
                            <a-form-item>
                                <a-input type="hidden" v-decorator="['session_id']" />
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :sm="12" v-show="isUnRelated">
                            <a-form-item :label="$t('program.upload_related_video.related_type' /* 关联方式 */)">
                                <a-select v-decorator="['choose_type', { initialValue: 1 }]">
                                    <a-select-option :value="1">{{ $t('program.upload_related_video.related_type_1' /* 新增视频 */) }}</a-select-option>
                                    <a-select-option :value="2">{{ $t('program.upload_related_video.related_type_2' /* 关联视频资源库 */) }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col v-show="isUnRelated && form.getFieldValue('choose_type') == 1">
                            <a-col :xs="24" :sm="12">
                                <a-form-item :label="$t('program.upload_related_video.video_name' /* 视频名称 */)">
                                    <a-input
                                        v-decorator="[
                                            'title',
                                            { rules: [{ required: form.getFieldValue('choose_type') == 1, message: $t('program.upload_related_video.video_name_required' /* 请输入视频名称 */) }] }
                                        ]"
                                    ></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item :label="$t('program.upload_related_video.title' /* 上传视频 */)">
                                    <a-upload
                                        name="Filedata"
                                        :action="uploadUrl"
                                        accept="video/*"
                                        :data="uploadVideoParams"
                                        :before-upload="info => beforeUpload(info, 'file')"
                                        :file-list="fileList"
                                        @change="handleFileChange"
                                        @remove="file => handleFileRemove(file, 'file')"
                                    >
                                        <a-input
                                            type="hidden"
                                            v-decorator="[
                                                'vid',
                                                { rules: [{ required: form.getFieldValue('choose_type') == 1, message: $t('program.upload_related_video.please_upload_video' /* 请上传视频 */) }] }
                                            ]"
                                        />
                                        <a-button style="width: 120px" type="primary">
                                            <a-icon type="plus"></a-icon>
                                            {{ $t('web.upload' /* 上传 */) }}
                                        </a-button>
                                    </a-upload>
                                    <template slot="extra">
                                        <span style="color: #f00">
                                            {{ $t('program.upload_related_video.video_size_limit' /* 视频大小不能超过500M 支持视频格式：*.avi; *.wmv; *.mp4;*.mov; *.flv; *.mkv; *.rmvb */) }}
                                        </span>
                                    </template>
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item :label="$t('program.upload_related_video.live_id' /* 关联直播 */)">
                                    <a-select v-decorator="['live_id']">
                                        <a-select-option v-for="(item, index) in liveList" :key="item.id" :value="item.id">{{ item.title }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item :label="$t('program.upload_related_video.is_online' /* 是否在学习平台/直播回放显示 */)">
                                    <a-switch
                                        v-decorator="[
                                            'is_online',
                                            {
                                                valuePropName: 'checked',
                                                initialValue: false,
                                                rules: [{ required: form.getFieldValue('choose_type') == 1, message: $t('program.upload_related_video.please_select' /* 请选择 */) }]
                                            }
                                        ]"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <!-- 搜索作者 -->
                                <search-user ref="searchUserRef" :form="form" :userInfo="userInfo" searchUrl="getRelatedVideoAuthors" :needForm="false" @select="handleUserSelect"></search-user>
                                <div style="color: #f00">{{ $t('program.upload_related_video.click' /* 请点击搜索，不要轻易新增 */) }}</div>
                            </a-col>

                            <!-- 关联作者列表 -->
                            <a-col :span="24">
                                <a-form-item :label="$t('program.upload_related_video.author_list' /* 关联作者列表 */)">
                                    <div
                                        type="hidden"
                                        v-decorator="[
                                            'user_list',
                                            {
                                                rules: [
                                                    { required: form.getFieldValue('choose_type') == 1, message: $t('program.upload_related_video.please_select_author_list' /* 请选择关联作者列表 */) }
                                                ]
                                            }
                                        ]"
                                    ></div>
                                    <a-table :columns="columns" :dataSource="userList" :pagination="false" :rowKey="record => record.user_id" size="small">
                                        <template slot="sort" slot-scope="text, record">
                                            <a-input-number v-model="record.sort" :min="0" />
                                        </template>
                                        <template slot="actions" slot-scope="text, record, index">
                                            <a-button type="danger" @click="() => userList.splice(index, 1)">{{ $t('program.upload_related_video.delete' /* 删除 */) }}</a-button>
                                        </template>
                                    </a-table>
                                    <template slot="extra">
                                        <span style="color: #f00">{{ $t('program.upload_related_video.author_list_tip' /* 排序的序号数字越大越靠前 */) }}</span>
                                    </template>
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item :label="$t('program.upload_related_video.cover_image' /* 视频封面 */)">
                                    <a-upload
                                        list-type="picture-card"
                                        :show-upload-list="false"
                                        :headers="uploadHeaders"
                                        :action="uploadImageUrl"
                                        :data="{ type: 1 }"
                                        accept="image/*"
                                        :before-upload="info => beforeUpload(info, 'image')"
                                        @change="handleImageChange"
                                        @remove="file => handleFileRemove(file, 'image')"
                                    >
                                        <a-input
                                            type="hidden"
                                            v-decorator="[
                                                'default_pic_url',
                                                {
                                                    rules: [
                                                        { required: form.getFieldValue('choose_type') == 1, message: $t('program.upload_related_video.please_upload_cover_image' /* 请上传视频封面 */) }
                                                    ]
                                                }
                                            ]"
                                        />
                                        <a-spin v-if="form && form.getFieldValue('default_pic_url')" :spinning="imageLoading">
                                            <img style="max-width: 100%" :src="form && form.getFieldValue('default_pic_url')" />
                                        </a-spin>
                                        <div v-else>
                                            <a-icon :type="imageLoading ? 'loading' : 'plus'" />
                                            <div class="ant-upload-text">{{ $t('program.upload_related_video.upload_img' /* 上传图片 */) }}</div>
                                        </div>
                                    </a-upload>
                                    <template slot="extra">
                                        <span style="color: #f00">{{ $t('program.upload_related_video.upload_img_tip' /* 建议尺寸1280*720px，支持JPG,GIF,PNG图片文件 */) }}</span>
                                    </template>
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item :label="$t('program.upload_related_video.sorting' /* 排序 */)">
                                    <a-input-number v-decorator="['order_by_id', { initialValue: 0 }]" :min="0" style="width: 100%" />
                                    <template slot="extra">
                                        <span style="color: #f00">{{ $t('program.upload_related_video.sorting_tip' /* 排序越大越靠前 */) }}</span>
                                    </template>
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item :label="$t('program.upload_related_video.intro' /* 视频简介 */)">
                                    <!-- 富文本编辑器 -->
                                    <wang-editor v-decorator="['intro']"></wang-editor>
                                </a-form-item>
                            </a-col>
                        </a-col>

                        <a-col :span="24" v-show="!isUnRelated || form.getFieldValue('choose_type') == 2">
                            <a-form-item :label="$t('program.upload_related_video.related_video' /* 关联视频 */)">
                                <a-select v-decorator="['video_id']">
                                    <a-select-option v-for="(item, index) in videoList" :key="item.id" :value="item.id">{{ item.id }}-{{ item.title }}-{{ item.author }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label="$t('program.upload_related_video.video_is_display' /* 是否在日程中显示 */)">
                                <a-switch
                                    v-decorator="[
                                        'video_is_display',
                                        { valuePropName: 'checked', rules: [{ required: true, message: $t('program.upload_related_video.please_select' /* 请选择 */) }] }
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :sm="12" v-show="form.getFieldValue('program_type') == 2">
                            <a-form-item>
                                <div v-decorator="['authorization_state']">
                                    <span>{{ $t('program.upload_related_video.authorization_state' /* 视频授权： */) }}</span>
                                    {{ formatAuthStateFun(form.getFieldValue('authorization_state')) }}
                                </div>
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :sm="12" v-show="form.getFieldValue('program_type') == 2">
                            <a-form-item>
                                <div v-decorator="['authorization_state_live']">
                                    <span>{{ $t('program.upload_related_video.authorization_state_live' /* 直播授权： */) }}</span>
                                    {{ formatAuthStateFun(form.getFieldValue('authorization_state')) }}
                                </div>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-spin>
            <div
                class="t-r"
                :style="{
                    position: 'absolute',
                    left: '0px',
                    bottom: '0px',
                    height: '50px',
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: '9999'
                }"
            >
                <a-button type="default" @click="handleCloseEvent">{{ $t('web.cancel' /* 取消 */) }}</a-button>
                <a-button class="ml10" type="danger" @click="handleCancelRelatedEvent" v-if="!isUnRelated">{{ $t('program.upload_related_video.cancel_related_video' /* 取消关联视频 */) }}</a-button>
                <a-button class="ml10" type="primary" @click="handleSaveEvent">{{ $t('program.upload_related_video.save' /* 保存 */) }}</a-button>
            </div>
        </a-drawer>
    </div>
</template>
<script>
import userApi from '@/request/apiList';
import SearchUser from '@/components/search-user';
import pick from 'lodash/pick';
import wangEditor from '@/components/wangEditor/index';

const fields = ['program_type', 'authorization_state', 'authorization_state_live'];
export default {
    name: 'UploadRelatedVideoDrawer',
    components: { SearchUser, wangEditor },
    props: {},
    data() {
        return {
            visible: false,
            sessionInfo: {},
            form: this.$form.createForm(this),
            loading: false,
            userInfo: {},
            fileList: [],
            uploadUrl: 'https://v.polyv.net/uc/services/rest?method=uploadfile',
            liveList: [], // 直播列表
            videoList: [], // 视频列表
            uploadVideoParams: {}, // 上传视频参数
            columns: [
                {
                    title: this.$t('program.upload_related_video.user_id' /* 用户ID */),
                    dataIndex: 'user_id',
                    key: 'user_id'
                },
                {
                    title: this.$t('program.upload_related_video.author_name' /* 作者名称 */),
                    dataIndex: 'author',
                    key: 'author'
                },
                {
                    title: this.$t('program.upload_related_video.author_org' /* 作者单位 */),
                    dataIndex: 'org_cnname',
                    key: 'org_cnname'
                },
                {
                    title: this.$t('program.upload_related_video.sorting' /* 作者单位 */),
                    dataIndex: 'sort',
                    key: 'sort',
                    scopedSlots: { customRender: 'sort' }
                },
                {
                    title: this.$t('program.upload_related_video.action' /* 操作 */),
                    dataIndex: 'actions',
                    key: 'actions',
                    scopedSlots: { customRender: 'actions' }
                }
            ],
            userList: [], // 关联作者列表
            imageLoading: false,
            uploadImageUrl: userApi.uploadImage,
            uploadHeaders: {},
            isUnRelated: false // 是否已关联视频
        };
    },
    watch: {
        userList(val) {
            this.$nextTick(() => {
                this.form.setFieldsValue({ user_list: val });
            });
        }
    },
    methods: {
        async show(data) {
            this.visible = true;
            this.sessionInfo = data;
            // 关联作者列表默认添加一条
            if (this.sessionInfo.duty_list?.length) {
                const user = {
                    user_id: this.sessionInfo.duty_list[0].userid,
                    author: this.sessionInfo.duty_list[0].real_name,
                    org_cnname: this.sessionInfo.duty_list[0].org_cnname,
                    sort: 0
                };
                this.userList.push(user);
            }

            const relatedData = await this.getRelatedListFun(this.sessionInfo.id);
            this.isUnRelated = relatedData.program_data.video_id === '0' ? true : false;
            this.liveList = relatedData.live_list;
            this.videoList = relatedData.video_list;

            this.uploadVideoParams = relatedData.video_upload_params;
            await this.$nextTick();
            this.form.setFieldsValue({
                title: this.sessionInfo.abstract_title,
                program_id: this.sessionInfo.id,
                session_id: this.sessionInfo.session_id,
                video_id: parseInt(relatedData.program_data.video_id) ? parseInt(relatedData.program_data.video_id) : null,
                video_is_display: relatedData.program_data.video_is_display == 1 ? true : false,
                ...pick(relatedData.program_data, fields)
            });
        },
        /**
         * ## 关闭抽屉
         */
        handleCloseEvent() {
            this.reset();
            this.visible = false;
        },
        /**
         * ## 保存
         */
        handleSaveEvent() {
            this.form.validateFields((err, values) => {
                values.video_is_display = values.video_is_display ? 1 : 0;
                values.is_online = values.is_online ? 1 : 0;

                if (!err) {
                    this.loading = true;
                    this.$request
                        .post({ url: 'saveProgramRelateVideo', data: values })
                        .then(res => {
                            if (res.code == 200) {
                                this.$message.success(this.$t('program.upload_related_video.save_success' /* 保存成功 */));
                                this.$emit('refresh');
                                this.reset();
                                this.visible = false;
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    this.form.validateFieldsAndScroll();
                }
            });
        },
        /**
         * ## 文件上传前
         */
        beforeUpload(file, type) {
            return new Promise((resolve, reject) => {
                // 检查文件大小是否超过500MB
                const isLt500M = file.size / 1024 / 1024 < 500;
                if (!isLt500M) {
                    this.$message.error(this.$t('program.upload_related_video.limit_number' /* 文件大小不能超过500MB! */));
                    return;
                }

                // 获取当前上传的文件后缀
                let suffix = file.name.split('.');
                suffix = suffix[suffix.length - 1].toLowerCase();
                // 图片
                if (type == 'image') {
                    let fileType = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
                    if (!fileType.includes(suffix)) {
                        this.$message.error(this.$t('program.upload_related_video.upload_type' /* 请上传后缀为{type}的格式 */), { type: fileType.join('|') });
                        return;
                    }
                }
                // 其他文件的验证
                if (type == 'file') {
                    // 取后台上传的后缀配置
                    let fileType = ['avi', 'wmv', 'mp4', 'mov', 'flv', 'mkv', 'rmvb'];
                    // 获取当前上传的文件后缀
                    if (!fileType.includes(suffix)) {
                        this.$message.error(this.$t('program.upload_related_video.upload_type' /* 请上传后缀为{type}的格式 */), { type: fileType.join('|') });
                        return;
                    }
                }
                return resolve(true);
            });
        },
        /**
         * ## 上传文件后
         */
        handleFileChange(info) {
            let tempFileList = [...info.fileList];
            tempFileList = tempFileList.slice(-1);
            tempFileList = tempFileList.map(file => {
                if (file.response) {
                    let { error, data } = file.response;
                    if (error == 0) {
                        // 上传成功
                        this.form.setFieldsValue({
                            vid: data[0].vid,
                            file_size: data[0].source_filesize,
                            duration: data[0].duration,
                            remark: JSON.stringify(data),
                            default_pic_url: data[0].images[0]
                        });
                    }
                }
                return file;
            });
            this.fileList = tempFileList;
        },
        /**
         * ## 删除文件
         */
        handleFileRemove(file, type) {
            return new Promise((resolve, reject) => {
                if (type === 'file') {
                    this.form.setFieldsValue({ vid: '', file_size: 0, duration: 0, remark: '' });
                    this.fileList = [];
                }
                if (type === 'image') {
                    this.form.setFieldsValue({ default_pic_url: '' });
                }
                return resolve(true);
            });
        },
        /**
         * ## 获取表单下拉列表相关数据
         */
        getRelatedListFun(program_id) {
            this.loading = true;
            return this.$request
                .get({ url: 'getRelatedVideos', data: { program_id } })
                .then(res => {
                    const { data } = res;

                    return data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /**
         * 格式化权限状态
         */
        formatAuthStateFun(state) {
            switch (state) {
                case 1:
                    return this.$t('program.upload_related_video.agree' /* 同意 */);
                case 2:
                    return this.$t('program.upload_related_video.refuse' /* 拒绝 */);
                default:
                    return this.$t('program.upload_related_video.un_confirm' /* 未确认 */);
            }
        },
        /**
         * ## 选中用户
         */
        handleUserSelect(userData) {
            const fields = ['user_id', 'author', 'org_cnname', 'sort'];
            userData.user_id = userData.id;
            userData.author = userData.real_name;
            userData.sort = 0; // 添加排序字段，默认0
            this.userList.push(pick(userData, fields));
        },
        /**
         * ## 上传图片改变
         */
        handleImageChange(info) {
            if (info.file.status === 'uploading') {
                this.imageLoading = true;
                return;
            }
            if (info.file.status === 'done') {
                let { code, data, message } = info.file.response;
                if (code == 200) {
                    this.form.setFieldsValue({ default_pic_url: this.$urlFilter(data.relative_path) });
                } else {
                    this.$message.error(message);
                }
                this.imageLoading = false;
            }
        },
        /**
         * ## 取消关联视频
         */
        handleCancelRelatedEvent() {
            this.$confirm({
                title: this.$t('web.tips' /* 温馨提示 */),
                content: this.$t('program.upload_related_video.confirm_cancel' /* 确定要取消关联视频吗？ */),
                onOk: () => {
                    this.$request.post({ url: 'cancelProgramVideo', data: { program_id: this.sessionInfo.id } }).then(res => {
                        this.$message.success(this.$t('program.upload_related_video.cancel_success' /* 取消成功 */));
                        this.$emit('refresh');
                        this.reset();
                        this.visible = false;
                    });
                }
            });
        },
        /**
         * ## 重置
         */
        reset() {
            this.form.resetFields();
            this.fileList = [];
            this.userList = [];
        }
    },
    mounted() {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
    }
};
</script>
<style lang="less" scoped>
:deep(.ant-card-head) {
    background: #fafafa;
    .ant-card-head-title {
        font-weight: bold;
    }
}
.ant-form-item {
    margin-bottom: 0px;
}
:deep(.ant-form-item-label) {
    line-height: 2;
}
</style>
